/**
 * On native, header gradients need to be rendered on top of the list otherwise they get dragged weirdly with refresh
 */
const NativeHeaderGradient = () => {
	return null;
};
export default NativeHeaderGradient;
